// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { fetchData, fetchEngineerStockDetails, postData, UPDATEDATASCHEDULE } from '../../../apiService';
// import { useAuth } from '../../../AuthContext';
// import { tokenIsExpired } from '../../../authUtils';
// import Select from 'react-select';
// import Button from '@mui/material/Button';
// import { TableContainer, Table, TableBody, TableRow, TableCell, Paper, Typography, TableHead } from '@mui/material';
// import CircularProgress from '@mui/material/CircularProgress';
// import { Link, useHistory } from 'react-router-dom';

// function WeeklySchedule() {
//     const history = useHistory();
//     const [daysOfWeek, setDaysOfWeek] = useState([]);
//     const [staffOptions, setStaffOptions] = useState([]);
//     const [selectedStaff, setSelectedStaff] = useState(null);
//     const [staffId, setStaffId] = useState('');
//     const [successMessage, setSuccessMessage] = useState("");
//     const [errorMessage, setErrorMessage] = useState("");
//     const [showUpdateButton, setShowUpdateButton] = useState(false);
//     const [showCreateButton, setShowCreateButton] = useState(false);
//     const { isAuthenticated, companyId, permissions, token, userId, logout } = useAuth();

//     useEffect(() => {
//         if (isAuthenticated && tokenIsExpired(token)) {
//             logout();
//             return;
//         }

//         fetchStaff();
//     }, [isAuthenticated, companyId, token, userId, logout]);

//     const fetchStaff = async () => {
//         try {
//             const response = await fetchData('StaffApi', `/${companyId}`);
//             if (response.responseCode === '1111') {
//                 const options = response.response_data.map(staff => ({
//                     value: staff.id,
//                     label: staff.firstName,
//                 }));
//                 setStaffOptions(options);
//             }
//         } catch (error) {
//             console.error('Error fetching Staff:', error);
//         }
//     };

//     const handleStaffChange = async (selectedOption) => {
//         setSelectedStaff(selectedOption);
//         setStaffId(selectedOption.value);
//         try {
//             const response = await fetchEngineerStockDetails('WeeklyScheduleAPI', companyId, selectedOption.value, token);
//             if (response.responseCode === '1111' && response.response_data) {
//                 setDaysOfWeek(response.response_data);
//                 const anyDayAvailable = response.response_data.some(day => day.isAvailable);
//                 const allDaysUnavailable = response.response_data.every(day => !day.isAvailable);
//                 setShowUpdateButton(anyDayAvailable);
//                 setShowCreateButton(allDaysUnavailable);
//             } else {
//                 console.error('Invalid response format', response);
//             }
//         } catch (error) {
//             console.error('Error fetching days of the week:', error);
//         }
//     };

//     const dayColors = {
//         Sunday: 'red',
//         Monday: 'darkgreen',
//         Tuesday: 'darkgreen',
//         Wednesday: 'darkgreen',
//         Thursday: 'darkgreen',
//         Friday: 'darkgreen',
//         Saturday: 'darkred'
//     };

//     const handleCheckboxChange = (dayName) => {
//         setDaysOfWeek(prevDaysOfWeek =>
//             prevDaysOfWeek.map(day =>
//                 day.dayName === dayName ? { ...day, isAvailable: !day.isAvailable } : day
//             )
//         );
//     };

//     const [isLoading, setIsLoading] = useState(false);

//     const handleSubmit = async () => {
//         setIsLoading(true);
//         const updatedSchedule = daysOfWeek.map(day => ({
//             CompanyId: companyId,
//             scheduleId: day.scheduleId,
//             DayID: day.dayID,
//             dayName: day.dayName,
//             isAvailable: day.isAvailable,
//             CreatedBy: userId,
//             EngineerId: staffId,
//         }));

//         const updatedScheduleData = { timings: updatedSchedule };

//         postData('WeeklyScheduleAPI', updatedScheduleData, token)
//             .then((response) => {
//                 console.log('WeeklySchedule Created success:', response);
//                 setSuccessMessage("WeeklySchedule Created successfully!");
//                 setErrorMessage("");
//                 window.location.reload();
//             })
//             .catch((error) => {
//                 console.error('Item Create error:', error);
//                 setIsLoading(false);
//             });
//     };

//     const handleUpdate = (event) => {
//         event.preventDefault();
//         setIsLoading(true);

//         setDaysOfWeek(prevDaysOfWeek => ({
//             ...prevDaysOfWeek,
//             UpdatedBy: userId,
//         }));

//         try {
//             UPDATEDATASCHEDULE(`WeeklyScheduleAPI/${staffId}`, daysOfWeek, token);
//             setSuccessMessage("WeeklySchedule Updated successfully!");
//             setErrorMessage("");

//         } catch (error) {
//             console.error('Schedule Update error:', error);
//             if (error.response) {
//                 console.error('Error response data:', error.response.data);
//                 console.error('Error response status:', error.response.status);
//                 console.error('Error response headers:', error.response.headers);
//             }
//             setErrorMessage("Failed to update the schedule. Please try again.");
//         } finally {
//             setIsLoading(false);
//         }
//     };



//     return (
//         <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '60%' }}>
//             <div className="w-full mb-2 flex">
//                 <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>WEEKLY SCHEDULE</h6>
//                 <div className="w-1/4 mr-2">
//                     <Select
//                         value={selectedStaff}
//                         onChange={handleStaffChange}
//                         options={staffOptions}
//                         placeholder="Select Staff"
//                         isSearchable
//                         styles={{ width: '250px' }}
//                     />
//                 </div>
//                 {showUpdateButton && (
//                     <Button onClick={handleUpdate} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: 'coral' }} disabled={isLoading}>
//                         {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update WeeklySchedule"}
//                     </Button>
//                 )}
//                 {showCreateButton && (
//                     <Button onClick={handleSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: 'coral' }} disabled={isLoading}>
//                         {isLoading ? <CircularProgress size={24} color="inherit" /> : "Create WeeklySchedule"}
//                     </Button>
//                 )}
//             </div>
//             <div className="w-full mb-5 flex justify-center" style={{ maxHeight: '600px', overflowY: 'auto' }}>
//                 <TableContainer component={Paper}>
//                     <Table>
//                         <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
//                             <TableRow>
//                                 <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', width: '15%' }}>DAY</TableCell>
//                                 <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px', width: '14%' }}>ISAVAILABLE</TableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {Array.isArray(daysOfWeek) && daysOfWeek.length > 0 ? (
//                                 daysOfWeek.map((item, index) => (
//                                     <TableRow key={index} className="customTableRows" style={{ backgroundColor: 'whitesmoke' }}>
//                                         <TableCell sx={{ fontSize: '18px', width: '14%', padding: '5px', fontWeight: 'bolder', color: dayColors[item.dayName] }}>{item.dayName}</TableCell>
//                                         <TableCell sx={{ fontSize: '14px', width: '14%', padding: '5px' }}>
//                                             <input
//                                                 type="checkbox"
//                                                 checked={item.isAvailable}
//                                                 onChange={() => handleCheckboxChange(item.dayName)}
//                                                 style={{ cursor: 'pointer', marginLeft: '-150px', height: '20px' }}
//                                             />
//                                         </TableCell>
//                                     </TableRow>
//                                 ))
//                             ) : (
//                                 <TableRow>
//                                     <TableCell colSpan={2} style={{ textAlign: 'center' }}>No data available</TableCell>
//                                 </TableRow>
//                             )}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             </div>
//             {errorMessage && (
//                 <div className="mt-4 flex justify-center">
//                     <Typography variant="body1" style={{ color: 'red' }}>{errorMessage}</Typography>
//                 </div>
//             )}
//             {successMessage && (
//                 <div className="mt-4 flex justify-center">
//                     <Typography variant="body1" style={{ color: 'green' }}>{successMessage}</Typography>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default WeeklySchedule;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { fetchData, fetchEngineerStockDetails, postData, UPDATEDATASCHEDULE } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import { TableContainer, Table, TableBody, TableRow, TableCell, Paper, Typography, TableHead } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Link, useHistory } from 'react-router-dom';

function WeeklySchedule() {
    const history = useHistory();
    const [daysOfWeek, setDaysOfWeek] = useState([]);
    const [formData, setFormData] = useState([]);

    const [staffOptions, setStaffOptions] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [staffId, setStaffId] = useState('');
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showUpdateButton, setShowUpdateButton] = useState(false);
    const [showCreateButton, setShowCreateButton] = useState(false);
    const { isAuthenticated, companyId, permissions, token, userId, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchStaff();
    }, [isAuthenticated, companyId, token, userId, logout]);

    const fetchStaff = async () => {
        try {
            const response = await fetchData('StaffApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(staff => ({
                    value: staff.id,
                    label: staff.firstName,
                }));
                setStaffOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Staff:', error);
        }
    };

    const handleStaffChange = async (selectedOption) => {
        setSelectedStaff(selectedOption);
        setStaffId(selectedOption.value);
        try {
            const response = await fetchEngineerStockDetails('WeeklyScheduleAPI', companyId, selectedOption.value, token);
            if (response.responseCode === '1111' && response.response_data) {
                setDaysOfWeek(response.response_data); // for create purpose
                setFormData(response.response_data); // for edit purpose
                const anyDayAvailable = response.response_data.some(day => day.isAvailable);
                const allDaysUnavailable = response.response_data.every(day => !day.isAvailable);
                setShowUpdateButton(anyDayAvailable);
                setShowCreateButton(allDaysUnavailable);
            } else {
                console.error('Invalid response format', response);
            }
        } catch (error) {
            console.error('Error fetching days of the week:', error);
        }
    };

    const dayColors = {
        Sunday: 'red',
        Monday: 'darkgreen',
        Tuesday: 'darkgreen',
        Wednesday: 'darkgreen',
        Thursday: 'darkgreen',
        Friday: 'darkgreen',
        Saturday: 'darkred'
    };

    const handleCheckboxChange = (dayName) => {
        setDaysOfWeek(prevDaysOfWeek =>
            prevDaysOfWeek.map(day =>
                day.dayName === dayName ? { ...day, isAvailable: !day.isAvailable } : day
            )
        );
    };

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        setIsLoading(true);
        const updatedSchedule = daysOfWeek.map(day => ({
            CompanyId: companyId,
            scheduleId: day.scheduleId,
            DayID: day.dayID,
            dayName: day.dayName,
            isAvailable: day.isAvailable,
            CreatedBy: userId,
            EngineerId: staffId,
        }));

        const updatedScheduleData = { timings: updatedSchedule };

        try {
            const response = await postData('WeeklyScheduleAPI', updatedScheduleData, token);
            console.log('WeeklySchedule Created success:', response);
            setSuccessMessage("WeeklySchedule Created successfully!");
            setErrorMessage("");
            window.location.reload();
        } catch (error) {
            console.error('Item Create error:', error);
            setErrorMessage("Failed to create the schedule. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    const handleUpdate = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        // Prepare the updated schedule data
        const updatedScheduleData = {
            timings: daysOfWeek.map(item => ({
                ...item,
                CompanyId: companyId,
                UpdatedBy: userId,
            })),
        };

        try {
            // Construct the URL
            const url = `WeeklyScheduleAPI/${staffId}`;
            // const baseURL = 'https://localhost:7291/api/';
            const baseURL = 'https://pp-api.off-ease.com/api/';
            console.log('Updating schedule with URL:', baseURL + url);
            console.log('Updated schedule data:', updatedScheduleData);

            // Send the update request
            const response = await axios.put(
                `${baseURL}${url}`,
                updatedScheduleData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log('Record updated successfully:', response.data);
            setSuccessMessage("WeeklySchedule Updated successfully!");
            setErrorMessage("");
            setTimeout(() => {
                setSuccessMessage("");
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Schedule Update error:', error);
            if (error.response) {
                console.error('Error response data:', error.response.data);
                console.error('Error response status:', error.response.status);
                console.error('Error response headers:', error.response.headers);
            }
            setErrorMessage("Failed to update the schedule. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '60%' }}>
            <div className="w-full mb-2 flex">
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>WEEKLY SCHEDULE</h6>
                <div className="w-1/4 mr-2">
                    <Select
                        value={selectedStaff}
                        onChange={handleStaffChange}
                        options={staffOptions}
                        placeholder="Select Staff"
                        isSearchable
                        styles={{ width: '250px' }}
                    />
                </div>
                {showUpdateButton && (
                    <Button onClick={handleUpdate} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: 'darkmagenta' }} disabled={isLoading}>
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update WeeklySchedule"}
                    </Button>
                )}
                {showCreateButton && (
                    <Button onClick={handleSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: 'coral' }} disabled={isLoading}>
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Create WeeklySchedule"}
                    </Button>
                )}
            </div>
            <div className="w-full mb-5 flex justify-center" style={{ maxHeight: '600px', overflowY: 'auto',marginTop:'20px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', width: '15%', textTransform: 'uppercase' }}>DAY</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', width: '14%', textTransform: 'uppercase' }}>ISAVAILABLE</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(daysOfWeek) && daysOfWeek.length > 0 ? (
                                daysOfWeek.map((item, index) => (
                                    <TableRow key={index} className="customTableRows" style={{ backgroundColor: 'whitesmoke' }}>
                                        <TableCell sx={{ fontSize: '13px', width: '14%', padding: '5px', fontWeight: 'bolder', color: dayColors[item.dayName] }}>{item.dayName}</TableCell>
                                        <TableCell sx={{ fontSize: '13px', width: '14%', padding: '5px' }}>
                                            <input
                                                type="checkbox"
                                                checked={item.isAvailable}
                                                onChange={() => handleCheckboxChange(item.dayName)}
                                                style={{ cursor: 'pointer', marginLeft: '-150px', height: '20px' }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={2} style={{ textAlign: 'center' }}>No data available</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {errorMessage && (
                <div className="mt-4 flex justify-center">
                    <Typography variant="body1" style={{ color: 'red' }}>{errorMessage}</Typography>
                </div>
            )}
            {successMessage && (
                <div className="mt-4 flex justify-center">
                    <Typography variant="body1" style={{ color: 'green' }}>{successMessage}</Typography>
                </div>
            )}
        </div>
    );
}

export default WeeklySchedule;
